
import React, { useEffect, useState } from "react";
import PageHeader from "../../../../../Layouts/PageHeader/PageHeader";
import TemplateSlider from "./TemplateSlider";
import { Button, Dropdown, OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { navigateToWithState, showToastMessage } from "../../../../../utils/commonFunctions";
import {
    MissionStore,
    setShowTemplateSlideToTrue,
    setShowTemplateDataTrue,
    setShowTemplateDataFalse,
    setTemplate,
    setShowTemplateSlideToFalse,
} from "../../../../../store/MissionSlice";
import {
    usageStore,
} from "../../../../../store/UsageSlice";
import CatalogueService from "../../../../../service/CatalogueService";
import { useNavigate, useParams } from "react-router-dom";

import { calculateEdgeUsage, calculatePayloadUsage, calculateUsagePercentage, calculate_Total_AOP_Usage, navigateTo, truncateNumber } from "../../../../../utils/commonFunctions";
import { Steps } from "../../Stepper.constants";
import CloseButton from "../../../../CommonComponents/CloseButton";
import MissionService from "../../../../../service/MissionService";
import Loader from "../../../../../Layouts/Loader/Loader";
import NewLoader from "../../../../CommonComponents/NewLoader";
import Select from "react-select";
import ImportTemplateButton from "./ImportTemplateButton";
////////////...................................//////////////////

const SelectTemplate = () => {

    const params = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { mission_name, sat_name, mission_id, sat_id, template_id } = params

    const [espaTempData, setEspaTempData] = useState({
        type: '',
        value: '',
    })
    const [templateList, setTemplateList] = useState([]);
    const [templateDataAvailable, setTemplateDataAvailable] = useState(false);
    const [matchTemplate, setMatchTemplate] = useState<any[]>([]);
    const [remainingTemplate, setRemainingTemplate] = useState<any[]>([]);
    const [vendorOptions, setVendorOptions] = useState<{ value: string; label: string }[]>([])
    const [satName, setSatName] = useState("")
    const [allEdges, setAllEdges] = useState([])
    const [allPayloads, setAllPayloads] = useState([])

    const [selectedVendor, setSelectedVendor] = useState<null | { value: string; label: string }>(null)

    const [showBtnGroup, setShowBtnGroup] = useState('');
    const [busUpdateInProgress, setBusUpdateLoading] = useState(false);

    const payloadSizePercent = useSelector(
        (state: { usage: usageStore }) => state.usage.payloadPerCent.size
    );
    const payloadWtPercent = useSelector(
        (state: { usage: usageStore }) => state.usage.payloadPerCent.weight
    );
    const payloadPowerPercent = useSelector(
        (state: { usage: usageStore }) => state.usage.payloadPerCent.power
    );
    const edgeSizeUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.edgeSizeUsage
    );
    const edgeWeightUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.edgeWeightUsage
    );
    const edgePowerUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.edgePowerUsage
    );
    const busSizeUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.busSizeUsage
    );
    const busWeightUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.busWeightUsage
    );
    const busPowerUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.busPowerUsage
    );
    const edgeSizePercent = useSelector((state: { usage: usageStore }) => state.usage.edgePerCent.size);
    const edgeWtPercent = useSelector((state: { usage: usageStore }) => state.usage.edgePerCent.weight);
    const edgePowerPercent = useSelector((state: { usage: usageStore }) => state.usage.edgePerCent.power);

    const payloadSizeUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.payloadSizeUsage
    );
    const payloadWeightUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.payloadWeightUsage
    );
    const payloadPowerUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.payloadPowerUsage
    );
    const aopCalculateUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.aopCalculateUsage
    );
    const totalPayloadAOPUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.totalPayloadAOPUsage
    );
    const totalEdgeAOPUsage = useSelector(
        (state: { usage: usageStore }) => state.usage.totalEdgeAOPUsage
    );
    const busSizePercent = useSelector(
        (state: { usage: usageStore }) => state.usage.busPerCent.size
    );
    const busWtPercent = useSelector(
        (state: { usage: usageStore }) => state.usage.busPerCent.weight
    );
    const busPowerPercent = useSelector(
        (state: { usage: usageStore }) => state.usage.busPerCent.power
    );


    const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);


    const [satelliteData, setSatelliteData] = useState<any>({});
    const [selectedTemplateId, setSelectedTemplateId] = useState<any>(null);

    const isTemplateSelected = useSelector(
        (state: { mission: MissionStore }) => state.mission.isTemplateSelected
    );
    const isTemplateData = useSelector(
        (state: { mission: MissionStore }) => state.mission.isTemplateData
    );

    //////////////////.............................////////////////

    const [errorMessg, setErrorMesg] = useState<any>("");
    const [Loading, setLoading] = useState(true);
    const [hover, setHover] = useState(true)
    const [showPercent, setShowPercent] = useState(false)
    const [importExportLoader, setImportExportLoader] = useState(false);


    const getTemplates = () => {
        const response = CatalogueService.getAllTemplates();
        response?.then((data) => {
            if (data.data) {
                const templates = data.data;
                setTemplateList(templates);
                setTemplateDataAvailable(true);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        getTemplates()
    }, [])

    useEffect(() => {
        if (sat_id && templateList?.length > 0) {
            MissionService.get_satellite_by_sat_id(sat_id, mission_id)?.then((sat) => {
                if (sat?.data) {
                    setSatName(sat?.data?.name)
                    MissionService.get_payload_by_sat_id(sat_id, mission_id)?.then((payalod) => {
                        MissionService.get_edge_by_sat_id(sat_id, mission_id)?.then((edge) => {
                            const all_payloas = payalod?.data ? payalod?.data : []
                            const all_edges = edge?.data ? edge?.data : []
                            setAllEdges(all_edges)
                            setAllPayloads(all_payloas)
                            setSatelliteData(sat.data)
                            calculate_Total_AOP_Usage(all_payloas, all_edges, dispatch)
                            calculatePayloadUsage(all_payloas, dispatch)
                            calculateEdgeUsage(all_edges, dispatch)
                            if (sat.data?.templateId) {
                                let templateId = sat.data?.templateId
                                let selectTemplate = templateList?.find((t) => t?.["uniqueId"] === templateId);
                                if ((sat.data?.['swapInfo']?.['totalPayloadSize'] + Number(selectTemplate?.["template-attribute"]?.["bus-size"]) < Number(selectTemplate?.["template-attribute"]?.["sizeInUnits"]))) {
                                    onAddTemplate(selectTemplate);
                                }
                            }
                        }).catch((err) => {
                            showToastMessage('error', "Error in getting edge")
                        })
                    }).catch((err) => {
                        showToastMessage('error', "Error in getting payloads")
                    })
                }
            }).catch((err) => {
                showToastMessage('error', "Something went wrong while getting satellite")
            })
        }
    }, [sat_id, templateList])

    useEffect(() => {
        if (payloadSizeUsage > 0 && templateList?.length > 0 && allPayloads?.length > 0) {
            getMatchFromTemplateList(templateList);
        }
    }, [payloadSizeUsage, payloadPowerUsage, templateList, selectedVendor, allPayloads])

    const update_satellite = async () => {
        setLoading(true)
        let sat = {
            ...satelliteData,
            templateId: selectedTemplateId,
            "swapInfo": {
                ...satelliteData?.swapInfo,
                totalBusMass: busWeightUsage,
                totalBusPower: busPowerUsage,
                totalBusSize: busSizeUsage,
                totalPayloadAop: totalPayloadAOPUsage,
                totalEdgeAop: totalEdgeAOPUsage,
                totalAop: aopCalculateUsage,

                totalUsedSize: truncateNumber((payloadSizeUsage + edgeSizeUsage + busSizeUsage), 2),
                totalUsedMass: truncateNumber((payloadWeightUsage + edgeWeightUsage + busWeightUsage), 2),
                totalUsedPower: truncateNumber((
                    Number(payloadPowerUsage) +
                    Number(edgePowerUsage) +
                    Number(busPowerUsage)
                ), 2),
                totalUsedSizePercent: truncateNumber((payloadSizePercent + edgeSizePercent + busSizePercent), 2),
                totalUsedMassPercent: truncateNumber((payloadWtPercent + edgeWtPercent + busWtPercent), 2),
                totalUsedPowerPercent: truncateNumber((payloadPowerPercent + edgePowerPercent + busPowerPercent), 2),
                totalPayloadSize: truncateNumber(payloadSizeUsage, 2),
                totalPayloadMass: truncateNumber(payloadWeightUsage, 2),
                totalPayloadPower: truncateNumber(payloadPowerUsage, 2),
                totalEdgeMass: edgeWeightUsage,
                totalEdgePower: edgePowerUsage,
                totalEdgeSize: edgeSizeUsage
            },
        };
        try {
            await MissionService.edit_satellite(mission_id, sat_id, sat);
            const res = await MissionService.add_bus(sat_id, mission_id, selectedTemplateId)
            if (res.data) {
                // Toast on destination page so user sees it after preview loads
                const successMessage = `Bus Design ${template_id ? 'updated' : 'added'} successfully`;
                navigateToWithState(
                    `${mission_name}/${mission_id}/${sat_name}/${sat_id}/review_satellite`,
                    navigate,
                    { BusDesignSuccessMessage: successMessage }
                );
            }
        } catch (err) {
            showToastMessage('error', "Something went wrong while adding Bus Design");
            console.log(err)
            setLoading(false);
        }
    }


    const getTemplateErrorMsg = () => {
        setMatchTemplate([]);
        setRemainingTemplate([]);
        dispatch(setShowTemplateDataFalse());
        setErrorMesg("No existing bus designs meet your requirements");
        setLoading(false)
    }

    const getUniqueById = (list: any[] = []) => {
        const map = new Map();
        list.forEach(item => {
            if (!map.has(item.uniqueId)) {
                map.set(item.uniqueId, item);
            }
        });
        return Array.from(map.values());
    };

    const getMatchFromTemplateList = (temp: any[]) => {
        const totalSize: number = edgeSizeUsage + payloadSizeUsage
        const totalWeight: number = edgeWeightUsage + payloadWeightUsage
        const totalPower: number = edgePowerUsage + payloadPowerUsage

        const filteredTemps = temp?.filter(t => t?.assembly[0]?.power?.['EPS']?.['user_data']?.['Available_Payload_Pos']?.length >= allPayloads?.length)
        const sizeNotMatch = filteredTemps?.filter((t) => t?.["template-attribute"]?.["sizeInUnits"] === 0)
        const sizeMatch = filteredTemps?.filter((t) => {
            return (
                t["name"] !== "Blank" &&
                totalSize + Number(t?.["template-attribute"]?.["bus-size"]) < t?.["template-attribute"]?.["sizeInUnits"]
            );
        });

        const totalSizeMatchTemp = [...sizeMatch, ...sizeNotMatch]

        if (totalSizeMatchTemp.length === 0) {
            getTemplateErrorMsg()
            return null
        }
        const weightNotMatch = totalSizeMatchTemp.find(t => t?.["template-attribute"]?.["maxWeightInKg"] === 0)
        const weightMatch = totalSizeMatchTemp.filter((t) => {
            return totalWeight + Number(t?.["template-attribute"]?.["bus-mass"]) < t?.["template-attribute"]?.["maxWeightInKg"];
        });
        const totalWeightMatchTemp = [...weightMatch, weightNotMatch]

        if (totalWeightMatchTemp?.length === 0) {
            getTemplateErrorMsg()
            return null
        }

        const powerMatch = totalWeightMatchTemp.filter((t) => {
            return totalPower + Number(t?.["template-attribute"]?.["bus-power"]) < t?.["template-attribute"]?.["battery-capacity"];
        });
        if (powerMatch.length === 0) {
            getTemplateErrorMsg()
            return null
        }

        powerMatch.sort((a, b) => {
            return (
                a?.["template-attribute"]?.["sizeInUnits"] -
                b?.["template-attribute"]?.["sizeInUnits"]
            );
        });
        let sizeSelected = powerMatch?.[0]?.["template-attribute"]?.["sizeInUnits"];
        const matchFinal = powerMatch.filter((t) => {
            return t?.["template-attribute"]?.["sizeInUnits"] === sizeSelected;
        });
        if (matchFinal?.length === 0) {
            getTemplateErrorMsg()
            return null
        }
        dispatch(setShowTemplateDataTrue());
        const unMatch = powerMatch.filter((el) => {
            return matchFinal.indexOf(el) === -1;
        });
        const allEspaTemp = unMatch.filter((t) => t?.["template-attribute"]?.['type'] === "espa");
        const allNotEspaTemp = unMatch.filter((t) => t?.["template-attribute"]?.['type'] !== "espa");
        const matchTemplate = [...allNotEspaTemp, ...allEspaTemp]?.filter(item => item.vendor === selectedVendor?.value);
        const uniqueVendors = Array.from(new Set(temp?.map(item => item.vendor)));
        if (selectedVendor) {
            setRemainingTemplate(getUniqueById(matchTemplate));
            setMatchTemplate(getUniqueById([...matchFinal].reverse().filter(item => item.vendor === selectedVendor.value)));
        } else {
            setRemainingTemplate(getUniqueById([...allNotEspaTemp, ...allEspaTemp]));
            setMatchTemplate(getUniqueById([...matchFinal].reverse()));
        }
        setVendorOptions(uniqueVendors?.filter(vendor => vendor && String(vendor).trim() !== "").map(vendor => ({
            value: String(vendor),
            label: String(vendor),
        })))
        setLoading(false)
        if (importExportLoader) {
            setImportExportLoader(false)
            showToastMessage('success', "Template Imported Successfully")
        }
        if (busUpdateInProgress) {
            setBusUpdateLoading(false);
            showToastMessage('success', "Updated bus and related satellite groups successfully")
        }
        return matchFinal;
    };

    const onAddTemplate = (data) => {
        if (data["template-attribute"]?.["type"] === 'espa') {
            setEspaTempData({
                type: data["template-attribute"]?.["type"],
                value: data["template-attribute"]?.["sizeInXYZ"],
            })
        } else {
            setEspaTempData({
                type: '',
                value: '',
            })
        }
        const allParams = {
            temp: data,
            templateDataAvailable: templateDataAvailable,
            dispatch: dispatch,
            powerUsage: payloadPowerUsage,
            edgePowerUsage: edgePowerUsage,
            edgeSizeUsage: edgeSizeUsage,
            edgeWeightUsage: edgeWeightUsage,
            sizeUsage: payloadSizeUsage,
            weightUsage: payloadWeightUsage
        }
        calculateUsagePercentage(allParams);
        setSelectedTemplateId(data["uniqueId"]);
        dispatch(setTemplate(data))
        setShowPercent(true)

    };


    const navigate_to_step = (step) => {
        if (step === 'Payloads') {
            navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_payload`, navigate)
        }
        if (step === 'Edge') {
            if (allEdges?.length > 0) {
                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_edge`, navigate)
            } else {
                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/add_new_edge`, navigate)
            }
        }
        if (step === 'Review' && selectedTemplateId !== '') {
            update_satellite()
        } if (step === 'Review' && selectedTemplateId === '') {
            return showToastMessage('error', "Please select bus design to proceed")
        }
    }
    const handleVendorChange = (selectedOption) => {
        setSelectedVendor(selectedOption);
    };

    const reset_filter = () => {
        setSelectedVendor(null);
    };


    const handleImportTemplate = (action?: string, templateId?: string) => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.json';

        fileInput.onchange = (event: any) => {
            if (event.target && event.target.files && event.target.files[0]) {
                const selectedFile = event.target.files[0];
                if (selectedFile && selectedFile.type === 'application/json') {
                    if (action === "bus_update") {
                        setBusUpdateLoading(true);
                    } else {
                        setImportExportLoader(true);
                    }
                    try {
                        const reader = new FileReader();
                        reader.onload = async (e) => {
                            const fileContent = e.target?.result as string;
                            try {
                                // Parse the JSON data
                                const blob = new Blob([fileContent], { type: "multipart/form-data" });
                                const file_data = new FormData();
                                file_data.append("file", blob, selectedFile.name);
                                if (action === "bus_update") {
                                    // AT-10150 FV-25.3 : API call to Update custom bus template
                                    await CatalogueService.putBusTemplate(templateId, file_data);
                                } else {
                                    await CatalogueService.importBusTemplate(file_data)
                                }
                                getTemplates()
                            } catch (error) {
                                if (action === "bus_update") {
                                    showToastMessage('error', "Failed to update bus template");
                                    setBusUpdateLoading(false);
                                } else {
                                    showToastMessage('error', "Failed to import bus template");
                                    setImportExportLoader(false);
                                }
                            }
                        };
                        reader.readAsText(selectedFile);
                    } catch (error) {
                        showToastMessage('error', "File format is not supported");
                        setBusUpdateLoading(false);
                        setImportExportLoader(false)
                    }
                } else {
                    showToastMessage('error', "File format is not supported");
                }
            }
        };

        fileInput.click();
    }


    const handleExportTemplate = (template) => {
        try {
            const jsonData = JSON.stringify(template, null, 2); // Convert JSON data to a string with indentation
            const blob = new Blob([jsonData], { type: 'application/json' }); // Use 'application/json' for JSON data
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'template.json';
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading template:', error);
            showToastMessage('error', 'Error downloading template');
        }
    }

    return (
        <div className={`h-100 w-100 ${importExportLoader && 'disable-view'}`} onClick={() => setShowBtnGroup("")}>
            {Loading && <Loader />}
            <PageHeader
                sat_name={satName}
                titles="Select Bus Design"
                description="Bus Design represents satellite subsystems like Bus, Radio, Power and components associated with them. These designs can be used for different missions. Here the platform recommends best suited templates for your mission based on your size power mass."
                active="New Mission"
                items={["Apps"]}
                isButton={false}
                showSwap={true}
                showPercent={showPercent}
                type={espaTempData?.['type']}
                value={espaTempData?.['value']}
            />
            {userData?.['feature-allowed']?.['Catalogue'] === 'Yes' &&
                <ImportTemplateButton
                    loading={importExportLoader}
                    onClick={handleImportTemplate}
                />
            }

            {isTemplateSelected && <TemplateSlider />}

            {templateDataAvailable && (
                <div className="d-flex">
                    <div className="w-15 bg-transparent border-right px-2 d-flex flex-column justify-content-between" >
                        <div className=" d-flex flex-column gap-2">
                            <span className="mt-2">Vendors</span>
                            <Select
                                className="w-100"
                                classNamePrefix="Select"
                                options={vendorOptions}
                                placeholder="Select Vendor"
                                onChange={handleVendorChange}
                                value={selectedVendor}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        e.preventDefault();
                                    }
                                }}
                                aria-label="vendor list"
                            />
                        </div>
                        <div className="d-flex justify-content-center" style={{ marginBottom: '7px' }}>
                            <button className='btn btn-outline-primary px-8  fs-18' onClick={reset_filter}>Reset</button>
                        </div>
                    </div>

                    <div className="d-flex flex-column flex-1 pop-scroll-xl py-5 ps-3 gap-4">


                        <div className='d-flex flex-column gap-1'>
                            {isTemplateData && <div className="d-flex">
                                <h4 className="mb-3">
                                    {isTemplateData
                                        ? "Recommended Bus Design"
                                        : "Create your own Design"
                                    }
                                </h4>
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                        <Popover id="popover-basic">
                                            <Popover.Body>
                                                <span className='color-text d-flex'>Recommended Bus Design based on your configuration.</span>
                                            </Popover.Body>
                                        </Popover>
                                    }
                                >
                                    <sup>
                                        <i className="fe fe-info ms-1 fs-14 text-info"></i>
                                    </sup>
                                </OverlayTrigger>
                            </div>}
                            <div className="d-flex flex-wrap gap-4">
                                {isTemplateData &&
                                    matchTemplate?.filter((t) => t["name"] !== "Blank" && !(allPayloads?.length > 2 && t["name"] === "XDSAT M600"))
                                        .map((data, i) => {
                                            return (
                                                <div key={data?.["uniqueId"]}
                                                    onClick={() => {
                                                        onAddTemplate(data);
                                                    }}
                                                >
                                                    <div
                                                        style={{ width: '440px', margin: '0px' }}
                                                        className={
                                                            data?.["uniqueId"] === selectedTemplateId
                                                                ? "common-card-box  active"
                                                                : "common-card-box "
                                                        }
                                                    >
                                                        <div className="common-card-header d-flex justify-content-between align-items-start">
                                                            <h4 className="mb-2 w-90 text-truncate" title={data?.["name"]}>{data?.["name"]}</h4>
                                                            <div className="btn-list more-button" onClick={(e) => {
                                                                e.stopPropagation()
                                                                setShowBtnGroup("");
                                                            }}>
                                                                <Dropdown drop='end' show={showBtnGroup === data?.["uniqueId"]}>
                                                                    <Dropdown.Toggle variant="transparent text-white fs-20"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (showBtnGroup === data?.["uniqueId"]) {
                                                                                setShowBtnGroup("");
                                                                            } else {
                                                                                setShowBtnGroup(data?.["uniqueId"]);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <i className="fe fe-more-vertical"></i>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item
                                                                            eventKey="0"
                                                                            onClick={() => {
                                                                                dispatch(setTemplate(data))
                                                                                dispatch(setShowTemplateSlideToTrue());
                                                                            }}
                                                                        >
                                                                            Summary
                                                                        </Dropdown.Item>
                                                                        {userData?.['feature-allowed']?.['Catalogue'] === 'Yes' &&
                                                                            <Dropdown.Item
                                                                                eventKey="2"
                                                                                onClick={() => {
                                                                                    handleExportTemplate(data);
                                                                                }}
                                                                            >
                                                                                Export
                                                                            </Dropdown.Item>
                                                                        }
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>

                                                        <div className="common-card-content">
                                                            <div className="d-flex flex-wrap">
                                                                <div className="stats-alpha">
                                                                    <strong>
                                                                        {data?.["template-attribute"]?.["bus-type"]}
                                                                    </strong>
                                                                    <span>Bus Type</span>
                                                                </div>
                                                                <div className="stats-alpha">
                                                                    <strong>
                                                                        {data?.["template-attribute"]?.["maxWeightInKg"] +
                                                                            " kg"}
                                                                    </strong>
                                                                    <span>Mass</span>
                                                                </div>
                                                                <div className="stats-alpha">
                                                                    <strong>
                                                                        {data?.["template-attribute"]?.[
                                                                            "battery-capacity"
                                                                        ] + " W"}{" "}
                                                                    </strong>
                                                                    <span>Power</span>
                                                                </div>

                                                                <div className="stats-alpha">
                                                                    <strong>
                                                                        {data?.["template-attribute"]?.["ADCS"]}
                                                                    </strong>
                                                                    <span>ADCS</span>
                                                                </div>
                                                                <div className="stats-alpha">
                                                                    <strong>
                                                                        {data?.['assembly']?.[0]?.['power']?.['Solar Panel']?.['user_data']?.['numUnits']}
                                                                    </strong>
                                                                    <span>Solar Panels</span>
                                                                </div>
                                                                <div className="stats-alpha">
                                                                    <strong>
                                                                        {data?.["template-attribute"]?.["propulsion"]}
                                                                    </strong>
                                                                    <span>Propulsion</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                            </div>
                        </div>

                        {remainingTemplate.length > 0 && (
                            <div className='d-flex flex-column gap-1'>
                                <h4 className="mb-3">Other Available Bus Design</h4>
                                <div className="d-flex flex-wrap gap-4">
                                    {remainingTemplate
                                        ?.filter((t) => t["name"] !== "Blank" && !(allPayloads?.length > 2 && t["name"] === "XDSAT M600"))
                                        ?.map((data, i) => {
                                            return (
                                                <div
                                                    style={{ width: '440px', margin: '0px' }}
                                                    className={
                                                        data["uniqueId"] === selectedTemplateId
                                                            ? "common-card-box active"
                                                            : "common-card-box "
                                                    }
                                                    key={data?.["uniqueId"]}
                                                    onClick={() => {
                                                        onAddTemplate(data);
                                                        if (data["template-attribute"]?.["type"] === 'espa') {
                                                            setEspaTempData({
                                                                type: data["template-attribute"]?.["type"],
                                                                value: data["template-attribute"]?.["sizeInXYZ"],
                                                            })
                                                        } else {
                                                            setEspaTempData({
                                                                type: '',
                                                                value: '',
                                                            })
                                                        }
                                                    }}
                                                >
                                                    {busUpdateInProgress && data?.["uniqueId"] === selectedTemplateId && <NewLoader canvasHeight={'auto'} canvasWidth={'auto'} loaderpage={'loader-page'} />}
                                                    <div className="common-card-header d-flex justify-content-between align-items-start" onClick={(e) => {
                                                        setShowBtnGroup("");
                                                    }}>
                                                        <h4 className="mb-2 w-90 text-truncate" title={data?.["name"]}>{data?.["name"]}</h4>
                                                        <div className="btn-list more-button" >
                                                            <Dropdown drop='end' show={showBtnGroup === data?.["uniqueId"]}>
                                                                <Dropdown.Toggle variant="transparent text-white fs-20"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (showBtnGroup === data?.["uniqueId"]) {
                                                                            setShowBtnGroup("");
                                                                        } else {
                                                                            setShowBtnGroup(data?.["uniqueId"]);
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fe fe-more-vertical"></i>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        eventKey="1"
                                                                        onClick={() => {
                                                                            dispatch(setTemplate(data))
                                                                            dispatch(setShowTemplateSlideToTrue());
                                                                        }}
                                                                    >
                                                                        Summary
                                                                    </Dropdown.Item>
                                                                    {userData?.['feature-allowed']?.['Catalogue'] === 'Yes' &&
                                                                        <Dropdown.Item
                                                                            eventKey="3"
                                                                            onClick={() => {
                                                                                handleExportTemplate(data);
                                                                            }}
                                                                        >
                                                                            Export
                                                                        </Dropdown.Item>
                                                                    }
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>

                                                    <div className="common-card-content">
                                                        <div className="d-flex flex-wrap">
                                                            <div className="stats-alpha">
                                                                <strong>
                                                                    {data?.["template-attribute"]?.["bus-type"]}
                                                                </strong>
                                                                <span>Bus Type</span>
                                                            </div>
                                                            <div className="stats-alpha">
                                                                <strong>
                                                                    {data?.["template-attribute"]?.[
                                                                        "maxWeightInKg"
                                                                    ] + " kg"}
                                                                </strong>
                                                                <span>Mass</span>
                                                            </div>
                                                            <div className="stats-alpha">
                                                                <strong>
                                                                    {data?.["template-attribute"]?.[
                                                                        "battery-capacity"
                                                                    ] + " W"}{" "}
                                                                </strong>
                                                                <span>Power</span>
                                                            </div>
                                                            <div className="stats-alpha">
                                                                <strong>
                                                                    {data?.["template-attribute"]?.["ADCS"]}
                                                                </strong>
                                                                <span>ADCS</span>
                                                            </div>
                                                            <div className="stats-alpha">
                                                                <strong>
                                                                    {
                                                                        data?.['assembly']?.[0]?.['power']?.['Solar Panel']?.['user_data']?.['numUnits']
                                                                    }
                                                                </strong>
                                                                <span>Solar Panels</span>
                                                            </div>
                                                            <div className="stats-alpha">
                                                                <strong>
                                                                    {data?.["template-attribute"]?.["propulsion"]}
                                                                </strong>
                                                                <span>Propulsion</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )}

                        {errorMessg !== '' && <div className="notification-alert info-text mt-4 fs-16">
                            <i className="fe fe-help-circle fs-20 text-danger me-3"></i>
                            {errorMessg}
                        </div>}
                    </div>
                </div>
            )}

            <div className="navigator-btn gap-3">
                <CloseButton />
                <div className="btn-group btn-grp-nav">
                    <Button
                        variant={hover ? "outline-primary" : "primary"}
                        type="button"
                        className={`d-flex align-items-center btn ${hover ? "btn-outline-primary" : "btn-primary"
                            } pt-1 pb-1 pe-4 ps-3 fs-14`}
                        onClick={() => {
                            if (allEdges.length > 0) {
                                if (isTemplateSelected) {
                                    dispatch(setShowTemplateSlideToFalse())
                                }
                                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_edge`, navigate)
                            } else {
                                if (isTemplateSelected) {
                                    dispatch(setShowTemplateSlideToFalse())
                                }
                                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/add_new_edge`, navigate)
                            }
                        }}
                        onMouseEnter={() => {
                            setHover(false);
                        }}
                        onMouseLeave={() => {
                            setHover(true);
                        }}
                    >
                        <i className="fe fe-chevron-left me-1 fs-16"></i> Back
                    </Button>
                    <Button
                        variant={hover ? "primary" : "outline-primary"}
                        type="submit"
                        className={`d-flex align-items-center btn ${hover ? "btn-primary" : "btn-outline-primary"
                            } pt-1 pb-1 pe-3 ps-4 fs-14`}
                        onClick={() => {
                            dispatch(setShowTemplateSlideToFalse())
                            if (!isEmpty(selectedTemplateId)) {
                                update_satellite()
                            } else {
                                showToastMessage('error', "Please select a bus design to proceed")
                            }
                        }}
                    >
                        Save & Continue
                        <i className="fe fe-chevron-right ms-1 fs-16"></i>
                    </Button>
                </div>
            </div>


            <div className="stepper-container">
                <div className="breadcrumb">
                    {Steps.map((data) => {
                        return <a
                            onClick={() => {
                                if (isTemplateSelected) {
                                    dispatch(setShowTemplateSlideToFalse())
                                }
                                navigate_to_step(data.title)
                            }}
                            className={data.title === 'Bus Design' ? 'active' : ''}
                            key={data.title}>
                            <span className="breadcrumb__inner">
                                <span className="breadcrumb__title">
                                    {data.svg}
                                </span>
                                <span className="breadcrumb__desc">{data.title}</span>
                            </span>
                        </a>
                    })}
                </div>
            </div>
        </div>
    );
};
export default SelectTemplate;
